import { FC } from 'react';
import { Checkbox, Card, Typography, Select } from 'antd';
import { TranslationOutlined } from '@ant-design/icons';
import styles from './consent-card.module.scss';
import dayjs from 'dayjs';
import { IConsentConfig } from '@datapeace/1up-frontend-shared-api';
import { useConsentLanguages } from '@datapeace/vms-visitor-hooks';

const { Text, Paragraph } = Typography;

interface ConsentCardProps {
  consentConfig?: IConsentConfig | null;
  consentGiven: boolean;
  setConsentGiven: (given: boolean, consentProvidedAt?: string) => void;
  style?: React.CSSProperties;
}

export const ConsentCard: FC<ConsentCardProps> = ({
  consentConfig = null,
  consentGiven,
  setConsentGiven,
  style,
}) => {
  const { languages, activeLang, activeLangCode, setActiveLangCode } =
    useConsentLanguages(consentConfig);

  if (!activeLang) return null;

  const handleLangChange = (code: string) => {
    setActiveLangCode(code);
    setConsentGiven(false, undefined);
  };

  const handleConsentChange = (checked: boolean) => {
    setConsentGiven(checked, checked ? dayjs().toISOString() : undefined);
  };

  return (
    <>
      <Card
        className={styles.ConsentContainer}
        bodyStyle={{ padding: 0 }}
        bordered
        style={style}
        title={
          <div className={styles.ConsentHeader}>
            <Text strong>Consent Notice</Text>
            {languages.length > 1 && (
              <Select
                size="small"
                value={activeLangCode}
                onChange={handleLangChange}
                options={languages.map((l) => ({
                  label: l.label,
                  value: l.code,
                }))}
                style={{ minWidth: 130 }}
                suffixIcon={<TranslationOutlined />}
                dropdownMatchSelectWidth={false}
              />
            )}
          </div>
        }
      >
        <div className={styles.ConsentBody}>
          <Paragraph className={styles.ConsentText}>
            {activeLang.text}
          </Paragraph>
        </div>
      </Card>

      <div className={styles.ConsentCheckboxRow} style={style}>
        <Checkbox
          checked={consentGiven}
          onChange={(e) => handleConsentChange(e.target.checked)}
        >
          <Text>I agree to the above consent notice</Text>
        </Checkbox>
      </div>
    </>
  );
};
